import { InfoIcon } from '@/app_components/widgets/RatesWidget/InfoIcon';
import { StarRating } from '@/app_components/widgets/RatesWidget/StarRating';
import type { RatesData } from '@/app_data/widgets/RedVentures/utils';
import { cn } from '@/app_lib/utils/utils';

interface RatesSavingsProps {
  product: RatesData['product'];
  institution: RatesData['institution'];
  isCd?: boolean;
  className?: string;
}

export const RatesSavings = ({ product, institution, className, isCd = false }: RatesSavingsProps) => {
  const tooltip =
    'Bankrate scores are objectively determined by our editorial team. Our scoring formula weighs several factors consumers should consider when choosing financial products and services.';

  /** (Business logic)
   * Append "CD" to the account name if the product name does not already include "CD" (case-insensitive) and the account is a CD.
   */
  const shouldAppendCd = !product.name.toLowerCase().includes(' cd') && isCd;

  return (
    <div className={cn('flex flex-col items-end gap-2 md:items-start', className)}>
      <div className='flex items-center gap-2'>
        <StarRating
          disabled
          rating={institution.reviews.overall_rating || 0}
        />
        <InfoIcon tooltip={tooltip} />
      </div>
      <div className='typography-xs flex flex-col'>
        <span className='uppercase font-medium'>
          {product.name} {shouldAppendCd && 'CD'} Account
        </span>
        <span>{institution.name}</span>
        <span className='font-medium'>{institution.insurance_information.disclosure}</span>
      </div>
    </div>
  );
};
